/**
 * index.js — Application entry point.
 * Wraps the App component with the Redux Provider and mounts it to the DOM.
 * Global styles (Bulma, FontAwesome, custom CSS) are imported here.
 */
import React from "react";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
// -----------------------------------------
import App from "./App";
import store from "System/reduxStore";
// -----------------------------------------
import "Styles/bulma.min.css";
import "Fontawesome/css/all.css";
import "Styles/css.css";

// -----------------------------------------
// -----------------------------------------
const Main = () => (
  <Provider store={store}>
    <App />
  </Provider>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Main />);
